import { useState } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import EnergyScheduleChart from './EnergyScheduleChart';
import ORScheduleChart from './ORScheduleChart';

export default function CombScheduleEnergyORCharts({ site, startDate, endDate, msSessionInfo, refreshKey }) {
    const [expandedChart, setExpandedChart] = useState(null);

    const isEnergyScheduleExpanded = expandedChart === 'EnergySchedule';
    const isORScheduleExpanded = expandedChart === 'EnergyOR';

    const handleEnergyScheduleToggle = () => {
        setExpandedChart(prev => {
            const next = prev === 'EnergySchedule' ? null : 'EnergySchedule';
            setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
            return next;
        });
    };

    const handleORScheduleToggle = () => {
        setExpandedChart(prev => {
            const next = prev === 'EnergyOR' ? null : 'EnergyOR';
            setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
            return next;
        });
    };

    return (
        <Grid container spacing={3}>
            <Grid
                item
                xs={12}
                md={isEnergyScheduleExpanded ? 12 : 6}
                lg={isEnergyScheduleExpanded ? 12 : 6}
                style={{ display: isORScheduleExpanded ? 'none' : 'block' }}
            >
                <EnergyScheduleChart
                    key={`EnergySchedule-${refreshKey}`}
                    site={site}
                    startDate={startDate}
                    endDate={endDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handleEnergyScheduleToggle}
                    refreshKey={refreshKey}
                />
            </Grid>

            <Grid
                item
                xs={12}
                md={isORScheduleExpanded ? 12 : 6}
                lg={isORScheduleExpanded ? 12 : 6}
                style={{ display: isEnergyScheduleExpanded ? 'none' : 'block' }}
            >
                <ORScheduleChart
                    key={`EnergyOR-${refreshKey}`}
                    site={site}
                    startDate={startDate}
                    endDate={endDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handleORScheduleToggle}
                    refreshKey={refreshKey}
                />
            </Grid>
        </Grid>
    );
}

CombScheduleEnergyORCharts.propTypes = {
    site: PropTypes.object.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    msSessionInfo: PropTypes.object.isRequired,
    refreshKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};